import type { SVGProps } from 'react';

export const ExpandDiagonalWindowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1836 0.5C21.5674 0.500167 23.4998 2.4326 23.5 4.81641V19.1836C23.4998 21.5674 21.5674 23.4998 19.1836 23.5H4.81641C2.43259 23.4998 0.500167 21.5674 0.5 19.1836V4.81641C0.500167 2.4326 2.4326 0.500167 4.81641 0.5H19.1836ZM4.81641 2.6582C3.62462 2.65837 2.65837 3.62462 2.6582 4.81641V19.1836C2.65837 20.3754 3.62462 21.3416 4.81641 21.3418H19.1836C20.3754 21.3416 21.3416 20.3754 21.3418 19.1836V4.81641C21.3416 3.62462 20.3754 2.65837 19.1836 2.6582H4.81641ZM11.5 14.4268L9.44141 16.4854L10.6895 17.7334C10.9522 17.9961 10.7774 18.4126 10.4053 18.4346L5.9375 18.5C5.697 18.4779 5.50027 18.2812 5.5 18.0625L5.56543 13.5947C5.56557 13.2445 6.00387 13.0697 6.2666 13.3105L7.51465 14.5586L9.57324 12.5L11.5 14.4268ZM18.082 5.5C18.3018 5.5 18.5 5.67516 18.5 5.91602L18.4336 10.3828C18.4556 10.7551 18.0167 10.9303 17.7529 10.6895L16.5 9.44141L14.4336 11.5L12.5 9.57324L14.5664 7.51465L13.3135 6.2666C13.0498 6.00389 13.2252 5.5875 13.5986 5.56543L18.082 5.5Z"
      fill="currentColor"
    />
  </svg>
);
